import { title } from 'process'
import { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

// Basic default theme
export const msj = {
  logo_image_url: 'msj/msj.svg',
  logo_height: 50,
  button_radius: 12,
  text_color: '#11263f',
  button_color: '#34b076',
  custom_token: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border: 2px solid #ef466f;
    border-radius: 100%;
    padding: 20px;
    margin: 10px;

    span {
      font-family: Poppins, sans-serif;
      font-size: 20px;
      font-weight: 600;
      color: #03162c;
      text-transform: uppercase;
    }

    img {
      display: none;
    }
  `,
}

// Basic default theme without numbers
export const msj_default_without_numbers = {
  ...msj,
  token_hidden: true,
  number_hidden: true,
  button_color: '#34b076',
  custom_token: false,
  title_margin: '10px',
}

// Theme based on the website design
// was initially made for app msjtradeshow
export const msjtradeshow = {
  body_background_image_url: 'msj/unicorn.webp',
  button_radius: 90,

  card_background_image_url: 'msj/map.svg',

  logo_image_url: 'msj/msj.svg',
  logo_height: 50,

  button_color: '#34b076',
  token_url: 'msj/msj.svg',
  token_margin_top: -18,
  token_margin_left: 5,
  token_hidden: true,

  number_hidden: true,

  text_color: '#11263f',

  title_color: '#f586a1',
  title_size: 38,
  title_lineheight: 48,
  title_weight: 700,

  subtitle_color: '#164d89',
  subtitle_size: 28,
  subtitle_lineheight: 32,
  subtitle_weight: 700,

  separator_background: css`linear-gradient(180deg, #164d89 0%, #132740 100%)`,
  separator_radius: 50,

  audio_background: css`linear-gradient(180deg, #f586a1 0%, #f586a1 50.52%, #fcc6a9 100%)`,

  image_icon_background_color: '#416db2',
  image_icon_border_color: '#416db2',

  button_centered: true,
  custom_button: css`
    font-family: 'Nunito', sans-serif;
    font-size: ${pxToRem(16)};
    font-weight: 700;
    line-height: ${pxToRem(16)};
    display: flex;
    align-items: center;
    width: fit-content;
    height: fit-content;
    padding: ${pxToRem(13)} ${pxToRem(21)};
    border-radius: ${pxToRem(90)};
    background-color: #3db076;
    border-color: #3db076;
    color: white;
    transition: all 0.2s;
    transition-timing-function: ease-in;
    cursor: pointer;

    &:hover {
      background-color: #278f5b !important;
      color: white !important;
      border-color: #278f5b !important;
    }
  `,
  custom_alternate_button: css`
    position: relative;
    padding: ${pxToRem(13)} ${pxToRem(21)};
    background-color: white;
    color: #23262f;
    border: none;

    label {
      z-index: 1;
    }

    &:hover {
      background-color: white !important;
      color: #3db076 !important;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: calc(100% - ${pxToRem(2)});
      height: calc(100% - ${pxToRem(2)});
      margin: ${pxToRem(1)};
      border-radius: inherit;
      background: white;
      opacity: 100%;
      z-index: 1;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: calc(100% + ${pxToRem(6)});
      height: calc(100% + ${pxToRem(6)});
      margin: ${pxToRem(-3)};
      border-radius: inherit;
      background: linear-gradient(to bottom, #70c58d 0%, #3e9c6c 50.52%, #faa87a 100%);
      opacity: 65%;
    }

    &.disabled {
      color: white;

      svg {
        z-index: 1;
      }

      &::before {
        display: none;
      }

      &::after {
        background: lightgrey;
        opacity: 1;
      }
    }
  `,
  button_half_border_color: 'rgb(247,247,254)',
}

// Theme based on the website design
// with token and number
export const msj_logo = {
  ...msjtradeshow,
  token_url: 'msj/msj.svg',
  token_margin_top: -18,
  token_margin_left: 5,
  token_hidden: false,
  number_hidden: false,
  number_color: '#f586a1',
  button_color: '#34b076',
}

// Theme based on the website design
// without token and number
export const msj_businesscards = {
  ...msjtradeshow,
  token_hidden: true,
  number_hidden: true,
  button_color: '#34b076',
}

// Theme based on the website design
// with title and subtitle gradient
export const msj_gradient = {
  ...msjtradeshow,
  title_background: css`linear-gradient(180deg, #f586a1 0%, #f586a1 50.52%, #fcc6a9 100%)`,
  subtitle_background: css`linear-gradient(180deg, #164d89 0%, #132740 100%)`,
  button_color: '#34b076',
}

// Theme based on the website design
// without title and subtitle gradient
export const msj_logo_gradient = {
  ...msj_gradient,
  ...msj_logo,
  button_color: '#34b076',
}

export const msj_lemans = {
  body_background_color: '#9BDCB9',
  title_font: 'Nunito, sans-serif',
  title_weight: 700,
  title_color: '#3F6CB3',
  subtitle_color: '#7B9CD0',
  subtitleH3_color: '#F7A2B7',
  subtitle_weight: 600,
  title_margin_left: 7,
  text_font: 'Nunito, sans-serif',
  text_weight: 400,
  text_color: '#0B121E',
  logo_image_url: 'msj/msj_lemans.png',
  header_margin_bottom: 20,
  token_hidden: true,
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#3F6CB3',
  button_hover_text_color: '#3F6CB3',
  button_radius: 50,
  button_outlined_border_color: '#3F6CB3',
  button_outlined_hover_border_color: '#3F6CB3',
  separator_color: '#3F6CB3',
  text_size: 18,
  subtitle_size: 28,
  subtitleH3_font_size: 23,
  title_size: 33,
}